<div class="card-content">
    <div class="tem-card">
        <div class="tem-card__header">
            <span class="tem-card__title">{{'correios.busca.title'|translateTA}}</span>
            <button nz-button nzType="primary" nzShape="circle" type="button"
                    nz-tooltip [nzTooltipTitle]="'correios.busca.consult'|translateTA" (click)="consultar()">
                <nz-icon nzType="search" />
            </button>
        </div>
        <div class="tem-card__body" [formGroup]="formValidation">
            <div class="cep-fields-grid">
                <div class="columns-data">
                    <div class="tem-field">
                        <span class="tem-field-label">{{'correios.busca.objectNumber'|translateTA}}</span>
                        <input nz-input formControlName="tracking" [placeholder]="'correios.busca.objectNumber'|translateTA"
                               type="text" (keyup.enter)="consultar()" />
                    </div>
                </div>
            </div>
            <div class="resultado">
                <ul *ngIf="mensagemObj.length > 0">
                    <li *ngFor="let item of mensagemObj; let i = index" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
                        (mouseover)="item.hover=true" (mouseout)="item.hover=false">
                        <div class="li-data" [class.li-alt]="i%2 == 0">
                            <span class="key-class">{{item.data}} - {{item.hora}}</span><span class="value-class"> - {{item.descricao}}</span>
                        </div>

                        <ng-template
                        cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="trigger"
                        [cdkConnectedOverlayOpen]="item.hover"
                        [cdkConnectedOverlayPositions]="positionPairs"
                        [cdkConnectedOverlayDisableClose]="true"
                        >
                            <div class="overlay-frame">
                                <div class="linepar"><div class="name">{{'correios.busca.tipo'|translateTA}}:</div><div class="edit">{{item.tipo}}</div></div>
                                <div class="lineimp"><div class="name">{{'correios.busca.status'|translateTA}}:</div><div class="edit">{{item.status}}</div></div>
                                <div class="linepar"><div class="name">{{'correios.busca.dataHora'|translateTA}}:</div><div class="edit">{{item.data}} - {{item.hora}}</div></div>
                                <div class="lineimp"><div class="name">{{'correios.busca.local'|translateTA}}:</div><div class="edit">{{item.cidade}} - {{item.uf}}</div></div>
                                <div class="linepar"><div class="name">{{'correios.busca.descricao'|translateTA}}:</div><div class="edit">{{item.descricao}}</div></div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                <nz-empty *ngIf="mensagemObj.length === 0" nzNotFoundImage="simple"
                          [nzNotFoundContent]="'correios.busca.empty'|translateTA"></nz-empty>
            </div>
        </div>
    </div>
</div>
